import { TFunction } from 'react-i18next';

export const THROTTLED_WARNING = 'automation is throttled';

import { type AutomationExecutionStatus } from '@kizen/api/automation';

// There are specific precendence rules that are being followed by the
// order of these statements.
export const getAutomationStatusDisplayData = (
  status: AutomationExecutionStatus,
  active: boolean,
  deleted: boolean,
  warning: string,
  isDebugActive: boolean,
  isInQueue: boolean
) => {
  if (status === 'completed') {
    return {
      label: (t: TFunction) => t('Completed'),
      statusColor: 'var(--color-viz-cat-2-primary)',
    };
  }
  if (status === 'cancelled') {
    return {
      label:
        warning === THROTTLED_WARNING
          ? (t: TFunction) => t('Cancelled (Throttled)')
          : (t: TFunction) => t('Cancelled'),
      statusColor: 'var(--color-viz-cat-7-primary)',
    };
  }
  if (status === 'failed') {
    return {
      label: (t: TFunction) => t('Failed'),
      statusColor: 'var(--color-viz-cat-7-primary)',
    };
  }
  if (deleted) {
    return {
      label: (t: TFunction) => t('Agentic Workflow Deleted'),
      statusColor: 'var(--color-viz-cat-7-primary)',
    };
  }
  if (!active || status === 'paused_by_automation') {
    return {
      label: (t: TFunction) => t('Inactive Agentic Workflow'),
      statusColor: 'var(--color-viz-cat-7-primary)',
    };
  }
  if (status === 'active') {
    if (isDebugActive) {
      return {
        label: (t: TFunction) => t('Paused (Debugging)'),
        statusColor: 'var(--color-viz-cat-3-primary)',
      };
    } else {
      return {
        label: (t: TFunction) =>
          isInQueue ? t('Active (Waiting)') : t('Active'),
        statusColor: 'var(--color-viz-cat-1-primary)',
      };
    }
  }
  if (status === 'paused') {
    return {
      label: (t: TFunction) => t('Paused'),
      statusColor: 'var(--color-viz-cat-3-primary)',
    };
  }
  if (status === 'paused_by_failure') {
    return {
      label: (t: TFunction) => t('Paused on Failure'),
      statusColor: 'var(--color-viz-cat-7-primary)',
    };
  }
};
